/** Web push on this device: ask permission, subscribe with the server's key, and return the subscription. */

const toBytes = (b64url: string) => {
  const b64 = (b64url + '='.repeat((4 - (b64url.length % 4)) % 4)).replace(/-/g, '+').replace(/_/g, '/');
  return Uint8Array.from(atob(b64), (c) => c.charCodeAt(0));
};

export const pushSupported = () => 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;

export const pushPermission = (): NotificationPermission | 'unsupported' => (pushSupported() ? Notification.permission : 'unsupported');

/** Must be called from a tap (iOS requires a user gesture, and an installed home-screen app). */
export const subscribePush = async (publicKey: string): Promise<PushSubscriptionJSON> => {
  if (!pushSupported()) throw new Error('This browser can’t receive notifications. On iPad, add the app to the Home Screen and open it from there.');
  const permission = await Notification.requestPermission();
  if (permission !== 'granted') throw new Error('Notifications are blocked. Allow them in the browser or system settings.');
  const reg = await navigator.serviceWorker.ready;
  const existing = await reg.pushManager.getSubscription();
  const sub = existing ?? await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: toBytes(publicKey) });
  return sub.toJSON();
};
